<template>
  <div v-if="teamIdLoaded" class="team-page">
    <team-header v-if="teamData" :team-data="teamData" :team-id="teamId" :is-user-logged-in="isUserLoggedIn" />

    <el-tabs v-model="activeTab" readonly class="team-page__tabs" @tab-click="handleChangeTab" size="large">
      <el-tab-pane label="About" name="about" lazy>
        <team-about :team-id="teamId" :team-data="teamData" :is-admin="isAdmin" :is-user-logged-in="isUserLoggedIn" />
      </el-tab-pane>

      <el-tab-pane label="Teammates" name="teammates" lazy>
        <team-teammates :team-id="teamId" :is-admin="isAdmin" ref="teammates" :is-user-logged-in="isUserLoggedIn" />
      </el-tab-pane>

      <el-tab-pane label="News" name="newsfeed" lazy>
        <team-newsfeed :team-id="teamId" :is-user-logged-in="isUserLoggedIn" :editable="true" />
      </el-tab-pane>

      <el-tab-pane label="Events" name="events" lazy>
        <team-events :team-id="teamId" :activityId="teamData ? teamData.activityId : null"
          :event-array="teamData ? teamData.events : []" :is-admin="isAdmin" @update-data="handleUpdateData"
          :is-user-logged-in="isUserLoggedIn" />
      </el-tab-pane>

      <el-tab-pane label="Calendar" name="calendar" lazy>
        <team-calendar :team-id="teamId" :is-user-logged-in="isUserLoggedIn"
          :event-array="teamData ? teamData.events : []" />
      </el-tab-pane>

      <el-tab-pane v-if="teamData?.galleryDriveShare" label="Gallery" name="gallery" lazy>
        <team-gallery :team-id="teamId" :is-admin="isAdmin" />
      </el-tab-pane>

      <el-tab-pane label="Documents" name="documents" lazy>
        <team-documents :teamId="teamId" :isAdmin="isAdmin"/>
      </el-tab-pane>
      
      <el-tab-pane label="Invitations" name="invitations" lazy v-if="isAdmin">
        <team-invitations :team-id="teamId" ref="invitations" />
      </el-tab-pane>

      <el-tab-pane label="Messages" name="messages" lazy v-if="isAdmin">
        <team-messages :team-id="teamId" ref="messages" />
      </el-tab-pane>

      <el-tab-pane label="Telegram" name="telegram" lazy v-if="isUserLoggedIn && teamData?.telegramChannel">
        <team-telegram :team-id="teamId" :channel="teamData.telegramChannel"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getTeam, getTeamIdByLink } from '@/api/team.js';

import TeamHeader from '@/components/teams/TeamHeader.vue';
import TeamNewsfeed from '@/components/teams/TeamNewsfeed.vue';
import TeamTeammates from '@/components/teams/TeamTeammates.vue';
import TeamEvents from '@/components/teams/TeamEvents.vue';
import TeamInvitations from '@/components/teams/TeamInvitations.vue';
import TeamMessages from '@/components/teams/TeamMessages.vue';
import TeamCalendar from '@/components/teams/TeamCalendar.vue';
import TeamAbout from './TeamAbout.vue';
import TeamTelegram from './TeamTelegram.vue';
import TeamDocuments from './TeamDocuments.vue';
import TeamGallery from './TeamGallery.vue';

export default {
  name: 'TeamPage',
  components: {
    TeamHeader,
    TeamNewsfeed,
    TeamTeammates,
    TeamEvents,
    TeamInvitations,
    TeamMessages,
    TeamCalendar,
    TeamAbout,
    TeamTelegram,
    TeamDocuments,
    TeamGallery,
  },
  data() {
    return {
      teamData: null,
      teamId: null,
      teamIdLoaded: false,
    };
  },
  computed: {
    activeTab: {
      get() {
        return this.$route.query.tab || 'newsfeed';
      },
      set(value) {
          this.$router.push({
            query: {
              tab: value,
            },
          });
        },
    },
    isAdmin() {
      return this.teamData ? this.teamData.hasAdminRights : false;
    },
    currentUser() {
      return this.$store.state.user;
    },
    isUserLoggedIn() {
      const { currentUser } = this;
      return Boolean(currentUser?.userId);
    },
  },
  methods: {
    async fetchTeamData() {
      const { teamId } = this;
      const { data, success } = await getTeam({ teamId });

      if (success) {
        this.teamData = data;
      }
    },
    handleChangeTab({ name }) {
      const { teamId, activeTab } = this;

      if (name !== activeTab) {
        this.$router.push({
          route: 'Event',
          params: {
            teamId,
          },
          query: {
            tab: name,
          },
        });
      }
    },
    handleUpdateData() {
      this.fetchTeamData();
      // if (this.$refs.teammates) {
      //   this.$refs.teammates.fetchTeammates();
      // }
    },
  },
  async created() {
    const { data } = await getTeamIdByLink({ link: this.$route.params.link });

    if (!(data && data.teamId)) {
      this.$router.replace({
        name: 'NotFound',
      });
    } else {
      this.teamId = data.teamId;
      this.fetchTeamData();
      this.teamIdLoaded = true;
    }
  },
};
</script>

<style lang="scss">
@import '~@/styles/shared/_globals.scss';

.team-page {
  &__tabs {
    .el-tabs__header {
      margin-bottom: var(--global-dimension-size-350);
    }

    .el-tabs__item {
      @include from('lg') {
        font-size: var(--font-size-300);
        height: var(--global-dimension-size-600);
      }
    }
  }
}
</style>
